import styled from 'styled-components';

import {Text} from '@yourcoach/shared/uikit/Text';
import {View} from '@yourcoach/shared/uikit/View';

export const Form = styled.form`
  position: relative;
`;

export const Description = styled(Text).attrs({
  as: 'p',
  variant: 'subtitle',
})`
  margin-bottom: 20px;
`;

export const ResendCodeButtonContainer = styled(View)`
  align-items: center;
  justify-content: center;
`;

export const InputContainer = styled(View)`
  margin-bottom: 20px;
  position: relative;
  align-items: center;
  justify-content: center;
`;

export const LoadingSpinnerContainer = styled(View)`
  position: absolute;
  left: 0;
  right: 0;
  top: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
